// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-container {
  width: 100%;
  max-width: 100%;
}

.slider-container .slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 0;
}

.slider-container .slider-labels span:first-child {
  margin-left: -10px;
  text-align: left;
}

.slider-container .slider-labels span:last-child {
  margin-right: -10px;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/questionnaireSlider/questionnaireSlider.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".slider-container {\n  width: 100%;\n  max-width: 100%;\n}\n\n.slider-container .slider-labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n  padding: 0;\n}\n\n.slider-container .slider-labels span:first-child {\n  margin-left: -10px;\n  text-align: left;\n}\n\n.slider-container .slider-labels span:last-child {\n  margin-right: -10px;\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
